import { CircularProgress, Grid2, IconButton } from "@mui/material";
import filterObjKeys from "../../../utility/misc/filterObjectKeys";
import SingleTwinSelect from "../Utilities/SingleTwinSelect";
import AutoHelp from "../Wrappers/AutoHelp";
import useUIBp from "../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../store/slices/UI";

// const options = [
//   {
//     icon: <Component />,
//     UIText: {
//       "es-CL": {
//         tooltip: "",
//       },
//     },
//   },
// ];

const ToggleIcon = (props) => {
  const { id, options, color = "info", disabled, onClick, xs, working } = props;
  const filteredProps = filterObjKeys(props, "options", "working");
  const { dispatch, UI, settings } = useUIBp();
  const selected = !!UI[id];
  const locale = settings.locale;

  const [opt1, opt2] = options;
  const { icon: icon1, UIText: UITxt1 = {} } = opt1 ?? {};
  const { icon: icon2, UIText: UITxt2 = {} } = opt2 ?? {};
  const { tooltip: ttp1, fixedTooltip: fttp1 } = UITxt1[locale] ?? {};
  const { tooltip: ttp2, fixedTooltip: fttp2 } = UITxt2[locale] ?? {};

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    dispatch(UIactions.toggle(id));
  };

  let icon = SingleTwinSelect(icon1, icon2, selected);
  let tooltip = SingleTwinSelect(ttp1, ttp2, selected);
  let fixedTooltip = SingleTwinSelect(fttp1, fttp2, selected);

  if (working) {
    icon = <CircularProgress size={14} />;
  }

  return (
    <Grid2 container size={{ xs }}>
      <AutoHelp {...{ tooltip, fixedTooltip, disabled: disabled || working }}>
        <IconButton
          {...filteredProps}
          {...{
            disabled: disabled || working,
            color: selected ? color : undefined,
            onClick: handleClick,
          }}
        >
          {icon}
        </IconButton>
      </AutoHelp>
    </Grid2>
  );
};

export default ToggleIcon;
